import { ComponentsApiKey, ScrollApiKey, EditorAPIKey } from '@/apis';
import { selection } from '@/stateManagement';

import type { Shell } from '@/apilib';
import type { CompRef } from 'types/documentServices';

export function createSpotlightStageApi(shell: Shell) {
  const editorAPI = shell.getAPI(EditorAPIKey);
  const componentsApi = shell.getAPI(ComponentsApiKey);
  const scrollApi = shell.getAPI(ScrollApiKey);
  const { store } = editorAPI;

  function getContainer(): CompRef {
    const focusedContainer = selection.selectors.getFocusedContainer(
      store.getState(),
    );

    return componentsApi.is.spotlightStageContainer(focusedContainer)
      ? focusedContainer
      : null;
  }

  function scrollByDelta(yDelta: number) {
    editorAPI.components.scroll.by(getContainer(), 0, yDelta, () => {
      // Trigger re-render of hoverBox/editBox and so on
      scrollApi.scrollTo({ scrollTop: 0 });
    });
  }

  return {
    getContainer,
    scrollByDelta,
  };
}
